import React from "react";
import { Link } from "react-router-dom";
import rampnalysisW from "../images/rampnalysis.svg";

function Header() {
  return (
    <header
      className={`fixed w-full z-50 md:bg-opacity-90 transition duration-300 ease-in-out`}
      style={{ backgroundColor: "#141924", borderBottom: "1px solid grey" }}
    >
      <div className="max-w-6xl mx-auto px-5 sm:px-6">
        <div className="flex items-center justify-between items-center h-16 md:h-16">
          <div className="flex-shrink-0 mr-4">
            <Link to="/" className="block" aria-label="Cruip">
              <img src={rampnalysisW} alt="Rampnslysis" width={"100%"} />
            </Link>
          </div>

          <nav className="flex flex-grow" style={{ zIndex: 1000 }}>
            <ul className="flex flex-grow justify-end flex-wrap items-center">
              <li>
                <a
                  href="https://www.rampnalysis.com/widget"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    backgroundColor: "#272727",
                    borderRadius: "10px",
                    cursor: "pointer",
                    fontSize: "12px",
                  }}
                  className={`font-medium text-white px-3 py-2 flex items-center transition duration-150 ease-in-out`}
                >
                  Launch App
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </header>
  );
}

export default Header;
